import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SettingsPage from './SettingsPage';
import withBackSupport from 'components/HOCs/withBackSupport';
import i18n from 'i18n';
import { createSelector, createStructuredSelector } from 'reselect';
import {
  getIsLoggedInSelector,
  getParentalDataSelector,
  getProfileData,
} from 'reducers/profile/selectors';
import { selectUILanguageTitleKey } from 'reducers/app/selectors';
import { selectIsAutostartTVEnabled } from 'reducers/autostart-tv/selectors';

const ITEMS = [
  { id: 'parental-lock', title: i18n.t('profile.parentalLock') },
  { id: 'autostart-tv', title: i18n.t('profile.autostarttv.title'), path: 'autostarttv' },
  { id: 'languages', title: i18n.t('profile.languages'), path: 'languages' },
];

const SettingsPageContainer = props => {
  return <SettingsPage {...props} />;
};

const getItemsSelector = createSelector(
  getProfileData,
  getIsLoggedInSelector,
  getParentalDataSelector,
  selectUILanguageTitleKey,
  selectIsAutostartTVEnabled,
  (profileData, isLoggedIn, parentalData, UILanguageTitleKey, isAutostartTVEnabled) => {
    return ITEMS.map(({ id, title, path, name }) => {
      let metadata = '';

      if (id === 'parental-lock') {
        const isEnabled = parentalData && parentalData.isParentalEnabled && isLoggedIn;
        metadata = isEnabled ? i18n.t('pc.on').toUpperCase() : i18n.t('pc.off').toUpperCase();
      } else if (id === 'languages') {
        metadata = i18n.t(UILanguageTitleKey);
      } else if (id === 'autostart-tv') {
        metadata = isAutostartTVEnabled
          ? i18n.t('pc.on').toUpperCase()
          : i18n.t('pc.off').toUpperCase();
      }
      return { id, title, path, name, metadata };
    });
  },
);

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  items: getItemsSelector,
});

export default compose(
  withBackSupport,
  connect(mapStateToProps),
)(SettingsPageContainer);
